import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=db943882&scoped=true"
import script from "./Preview.vue?vue&type=script&setup=true&lang=ts"
export * from "./Preview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Preview.vue?vue&type=style&index=0&id=db943882&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db943882",
  null
  
)

export default component.exports